import { Component, EnvironmentInjector, inject, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { LoggerService } from '../../../../shared/services/logger.service';
import { ToastService } from '../../services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { ChatService } from '../../services/in-app-services/chat.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.page.html',
  styleUrls: ['./menu.page.scss'],
  standalone: false,
})
export class MenuPage implements OnInit {
  authService = inject(AuthService);
  injector = inject(EnvironmentInjector);
  loggerService = inject(LoggerService);
  toastService = inject(ToastService);
  translateService = inject(TranslateService);
  chatService = inject(ChatService);
  constructor() {}

  ngOnInit() {}

  openChat() {
    this.chatService.openChat();
  }
} 
